module.exports = __webpack_public_path__ + "static/media/134-liechtenstein.8860305a.svg";